import './styles/main.scss';
import Vue from 'vue';
import App from './App.vue';
import store from './store/';
import router from './router';
import VueRouter from 'vue-router';
import './registerServiceWorker';
import SocialSharing from 'vue-social-sharing';

Vue.use(SocialSharing);
Vue.use(VueRouter);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created: () => {
    store.dispatch('set_configuration');
  },
  render: h => h(App),
}).$mount('#app');
